import * as React from 'react';
import { AvatarProps } from '../Avatar';

export type GroupType = 'stretched' | 'condensed';
export type AvatarGroupSize = 'medium' | 'small';

type AvatarItemProps = {
  ariaLabel?: AvatarProps['ariaLabel'];
  color?: AvatarProps['color'];
  imgProps?: AvatarProps['imgProps'];
  name?: AvatarProps['name'];
  text?: AvatarProps['text'];
  onClick?: AvatarProps['onClick'];
  placeholder?: AvatarProps['placeholder'];
  title?: AvatarProps['title'];
  dataHook?: AvatarProps['dataHook'];
};
export interface AvatarGroupProps {
  dataHook?: string;
  className?: string;
  type?: GroupType;
  size?: AvatarGroupSize;
  showDivider?: boolean;
  maxItems?: number;
  items: AvatarItemProps[];
}

export default class AvatarGroup extends React.PureComponent<AvatarGroupProps> {}
